import type {ChatMode, ChatType} from '@Components/ai-chat-window/ai-chat-window.types';

export const AI_CHAT_HOME_SCROLL_ID = 'ai-chat-home-scroll-container';
export const AI_CHAT_PROMPT_BOX_ID = 'ai-chat';
export const AI_CHAT_QUICK_TIPS_URL_SEGMENT = 'quickTips';

export interface HistoryItem {
  idAiChat: string;
  title?: string;
  assetHashedFilename?: string;
  type: ChatType;
  mode: ChatMode;
  updatedAt: number;
}
